import { Component } from '@angular/core';
import { TextInput } from '../../../../../../shared/components/text-input/text-input';
import { FormHandlerBase } from '../../../../../../shared/components/classes/form-handler-base.class';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'smm-newsletter',
  imports: [TextInput, ReactiveFormsModule, TranslateModule],
  templateUrl: './newsletter.html',
  styleUrl: './newsletter.scss',
})
export class Newsletter extends FormHandlerBase {
  constructor() {
    super();
    this.loadForm({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.markFormAsTouched();
      return;
    }
    // Handle newsletter subscription logic here
    console.log('Newsletter Subscription:', this.form.value);
  }
}
